import axios from "axios";

const api = {
  getUser: () => {
    return axios.get(`${process.env.REACT_APP_API_URL}/external/auth/me`, { withCredentials: true });
  },

  getBasket: () => {
    return axios.get(`${process.env.REACT_APP_API_URL}/external/baskets`, { withCredentials: true });
  },

  removeFromBasket: (asset) => {
    let data = new FormData();
    data.append("key", asset);

    return axios.post(
      `${process.env.REACT_APP_API_URL}/external/baskets/removeIntegrationAsset`,
      data,
      { withCredentials: true }
    );
  },

  addToBasket: (asset) => {
    let data = new FormData();
    data.append("key", asset);

    return axios.post(
      `${process.env.REACT_APP_API_URL}/external/baskets/addIntegrationAsset`,
      data,
      { withCredentials: true }
    );
  },

  logout: () => {
    return axios.post(`${process.env.REACT_APP_API_URL}/auth/logout`, null, { withCredentials: true });
  },

  checkInBasket: (key) => {
    let data = new FormData();
    data.append("key", key);
    return axios.post(
      `${process.env.REACT_APP_API_URL}/external/baskets/checkIntegrationAsset`,
      data,
      { withCredentials: true }
    );
  },

  basketCount: () => {
    return axios.get(
      `${process.env.REACT_APP_API_URL}/external/baskets/count`,
      { withCredentials: true }
    );
  },
};

export default api;
